// extracted by mini-css-extract-plugin
module.exports =  {"chips":"chips-Uw41c"};